<template>
  <div class="circle-progress" :style="{ width: size + 'px', height: size + 'px' }">
    <svg :width="size" :height="size" viewBox="0 0 100 100">
      <circle
          class="circle-progress-background"
          cx="50"
          cy="50"
          r="45"
      ></circle>
      <circle
          class="circle-progress-bar"
          :class="{'over-50': progress > 50}"
          cx="50"
          cy="50"
          r="45"
          :style="circleStyle"
      ></circle>
    </svg>
    <div class="circle-progress-text">
      {{ progress }}%
    </div>
  </div>
</template>

<script>
export default {
  name: 'CircleProgress',
  props: {
    size: {
      type: Number,
      default: 100,
    },
    progress: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    circleStyle() {
      const circumference = 2 * Math.PI * 45;
      const offset = circumference - (this.progress / 100) * circumference;
      return {
        strokeDasharray: `${circumference} ${circumference}`,
        strokeDashoffset: offset,
      };
    },
  },
};
</script>

<style scoped>
.circle-progress {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

svg {
  transform: rotate(-90deg);
}

.circle-progress-background {
  fill: none;
  stroke: #eaecf3;
  stroke-width: 5;
}

.circle-progress-bar {
  fill: none;
  stroke: #58bd4a;
  stroke-width: 5;
  stroke-linecap: round;
  transition: stroke-dashoffset 0.6s ease, stroke 0.6s ease;
}

.circle-progress-bar.over-50 {
  stroke: #d24242;
}

.circle-progress-text {
  position: absolute;
  font-size: 1.5em;
  color: #606266;
  font-weight: bold;
}
</style>
